import styled from "styled-components";
export const ProjectDetailsSc = styled.div`
  margin: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .card-container {
    padding: 20px 30px;
    background-color: #b2b5fc;
    border-radius: 3px;
    transition: all 1s;
    color: black;
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 40%;
  }
  .card-container:hover {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    /* scale: 1.2; */
  }
  .project-name {
    align-self: center;
  }
`;
